import { lazy } from 'react';

export const ProductSelectionBestOffersPage = lazy(
  () =>
    import(
      /* webpackPreload: true */
      /* webpackChunkName: "ProductSelectionBestOffersPage" */
      './ProductSelectionBestOffersPage'
    ),
);
